<template>
  <div class="login-wrapper">
    <img
      src="@/assets/logo.png"
      alt="App Logo"
      class="login-logo"
    >
    <div class="login-card">
      <h1 class="login-title">
        Admin Login
      </h1>
      <form @submit.prevent="handleLogin">
        <div class="input-group">
          <label for="username">Username</label>
          <input
            id="username"
            v-model="username"
            type="text"
            class="modern-input"
            required
          >
        </div>
        <div class="input-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            class="modern-input"
            required
          >
        </div>
        <button
          type="submit"
          class="login-button"
        >
          Login
        </button>
        <p
          v-if="error"
          class="error-message"
        >
          {{ error }}
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  data() {
    return {
      username: '',
      password: '',
      error: null,
    };
  },
  methods: {
    async handleLogin() {
      try {
        const response = await api.login({
          username: this.username,
          password: this.password,
        });
        localStorage.setItem('admin-token', response.data.token);
        this.$router.push('/admin/dashboard');
      } catch (err) {
        this.error = 'Invalid username or password.';
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  flex-direction: column; /* Added to stack items vertically */
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #000942 0%, #1e2b7e 100%);
  padding: 20px;
}

.login-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 450px;
  text-align: center;
}

.login-logo {
  max-width: 324px; /* Increased max-width */
  margin-bottom: 20px; /* Adjusted margin-bottom */
}

.login-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 30px;
}

.input-group {
  margin-bottom: 20px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #4a5568;
}

.modern-input {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.modern-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
}

.login-button {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.error-message {
  color: #ef4444;
  text-align: center;
  margin-top: 20px;
  font-weight: 500;
  font-size: 0.95rem;
}
</style>